import React from 'react';
import { Section } from './Shared';
export function HowItWorks() {
  const steps = [{
    title: 'Escríbenos por WhatsApp',
    description: 'Cuéntanos tu situación en un mensaje. Nuestro equipo te responde inmediatamente y te indica exactamente qué necesitas según tu caso.'
  }, {
    title: 'Sube tu Historia Laboral',
    description: 'Descárgala gratis desde Colpensiones o tu fondo privado y compártela con nosotros de forma segura. Si no sabes cómo descargarla, te explicamos.'
  }, {
    title: 'Recibe tu Diagnóstico',
    description: 'Nuestro equipo de analistas y juristas analiza tu caso y te entrega el audio explicativo y el PDF de hoja de ruta directamente en tu WhatsApp. Sin reuniones. Sin desplazamientos. Sin esperas innecesarias.'
  }];
  return <Section bg="white" data-id="element-99">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-100">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-101">
          Tres pasos. Sin filas. Sin vueltas.
        </h2>
      </div>

      <div className="max-w-5xl mx-auto" data-id="element-102">
        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-103">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-0.5 bg-slate-200 z-0" data-id="element-104"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-105">
              <div className="w-16 h-16 bg-slate-900 text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 shadow-md border-4 border-white" data-id="element-106">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-107">
                PASO {index + 1} <br data-id="element-108" /> {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-109">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}